import { parseDateRange, checkDateInRange } from '../../utils/dateUtils';
import {
  REQUEST_STATUS,
  REQUEST_TAGS,
} from '../../../constants/request.constant';
import { STAGE_TYPES } from '../../../constants/workflow.constant';

export const matchesDateFilter = (request, dateRange) => {
  if (!dateRange) return true;

  const submissionDate = new Date(request.createdAt);
  const lastActionDate = new Date(request.updatedAt);
  const { startDate, endDate } = parseDateRange(dateRange);

  if (startDate || endDate) {
    return (
      checkDateInRange(submissionDate, startDate, endDate) ||
      checkDateInRange(lastActionDate, startDate, endDate)
    );
  }

  return true;
};

export const computeRequestTag = (request, status) => {
  const activeProgress = request?.requests_progresses?.find((p) => p.active);
  if (!activeProgress) return null;

  if (status === REQUEST_STATUS.PENDING) {
    const approvalCode =
      activeProgress.StageRelation?.Stage?.ApprovalType?.code;
    return approvalCode === REQUEST_STATUS.SEND_BACK
      ? REQUEST_TAGS.SENT_BACK
      : REQUEST_TAGS.NEW;
  }

  if (status === REQUEST_STATUS.IN_PROGRESS) {
    const stageType = activeProgress.StageRelation?.Child?.StageType?.type;
    return stageType === STAGE_TYPES.SUBMISSION
      ? REQUEST_TAGS.UNDER_SUBMISSION
      : REQUEST_TAGS.UNDER_REVIEW;
  }

  return null;
};
